{
  "pages": {
    "purchaseOrders": {
      "title": "Commandes d'achat"
    },
    "purchaseRequests": {
      "title": "Demandes d'achat"
    },
    "goodsReceipts": {
      "title": "Réceptions marchandises"
    },
    "rfqs": {
      "title": "Appels d'offres"
    },
    "quotations": {
      "title": "Comparaison des devis"
    },
    "vendorBills": {
      "title": "Factures fournisseurs et paiements"
    },
    "catalogs": {
      "title": "Catalogues fournisseurs"
    },
    "contracts": {
      "title": "Contrats et réapprovisionnement"
    },
    "reports": {
      "title": "Rapports achats"
    },
    "setup": {
      "title": "Configuration achats"
    },
    "vendorPortal": {
      "title": "Portail fournisseur",
      "loginDescription": "Connexion libre-service fournisseur",
      "verifyDescription": "Vérification de votre lien de connexion…",
      "signInDescription": "Connectez-vous pour voir les appels d'offres, commandes et factures",
      "welcome": "Bienvenue, {{supplierName}}"
    },
    "dashboard": {
      "title": "Tableau de bord achats",
      "description": "KPI du cycle d'achat pour votre société et périmètre d'approbation",
      "operationalDetails": "Détails opérationnels",
      "pendingApprovals": "Approbations en attente",
      "pendingGrns": "GRN en attente",
      "stockReceiptTitle": "Réception stock",
      "stockReceiptMessage": "L'ancien /v1/purchases est retiré — recevez le stock uniquement via la comptabilisation GRN sous Réceptions marchandises."
    },
    "publishedSupplierCatalogsForDirectBuying": "Published fournisseur catalogs pour direct buying",
    "supplierContractsAndInventoryDrivenAuto": "Fournisseur contracts et inventory-driven auto-reorder",
    "submitForQcApprovalThenPost": "Submit pour QC approbation, then post GRN à increase inventory",
    "approvedPosInventoryUpdatesOnlyOn": "Approved POs — inventory updates only on GRN publication",
    "internalProductRequestsBeforeRfqAnd": "Internal produit requests before RFQ et purchase order",
    "compareSupplierQuotationsByPriceDelivery": "Compare fournisseur quotations by price, delivery et terms before sélectionnerion.",
    "exportOperationalAndSpendReports": "Export operational et spend rapports",
    "requestForQuotationInviteMultipleSuppliers": "Request pour quotation — invite multiple fournisseurs avec multiple produit lines",
    "approvalWorkflowsAndVendorPortalConfiguration": "Approbation flux de travails et vendor portal configuration",
    "postVendorPaymentsWithBillAllocations": "Post vendor paiements avec bill allocations et payable tracking.",
    "rfqsPurchaseOrdersAndInvoiceStatus": "RFQs, purchase orders, et facture status"
  },
  "toast": {
    "poSubmittedForApproval": "Commande soumise pour approbation",
    "purchaseOrderCancelled": "Commande d'achat annulée",
    "grnCreatedQcPending": "GRN {{grnNumber}} créé — approuver QC puis comptabiliser",
    "quotationRecorded": "Devis enregistré",
    "poCreatedSubmitApproval": "Commande {{poNumber}} créée — soumettre pour approbation",
    "winningQuotationSelected": "Devis retenu sélectionné",
    "reportExported": "{{reportType}} exporté",
    "loginLinkSent": "Si enregistré, un lien de connexion a été envoyé (voir les logs serveur en dev)",
    "vendorPortalInviteSent": "Invitation portail fournisseur envoyée",
    "rfqCreatedAndSent": "Appel d'offres créé et envoyé aux fournisseurs",
    "quotationSubmitted": "Devis soumis",
    "invoiceSubmitted": "Facture soumise",
    "signedInVendorPortal": "Connecté au portail fournisseur",
    "requestSubmitted": "Demande {{requestNumber}} soumise",
    "requestCancelled": "Demande annulée",
    "threeWayMatchCompleted": "Rapprochement tripartite terminé",
    "vendorBillCreated": "Facture fournisseur créée",
    "vendorPaymentPosted": "Paiement fournisseur comptabilisé",
    "grnSubmittedForQc": "GRN soumis pour approbation QC",
    "grnCancelled": "GRN annulé",
    "grnPosted": "GRN {{grnNumber}} comptabilisé — stock mis à jour",
    "autoReorderCreated": "Réapprovisionnement auto : {{count}} demande(s) d'achat créée(s)"
  },
  "errors": {
    "submitFailed": "Échec de la soumission",
    "cancelFailed": "Échec de l'annulation",
    "poNoLineItems": "La commande n'a pas de lignes",
    "createGrnFailed": "Échec de la création du GRN",
    "loadQuotationComparisonFailed": "Échec du chargement de la comparaison des devis",
    "selectRfqFirst": "Sélectionnez d'abord un appel d'offres",
    "selectSupplier": "Sélectionnez un fournisseur",
    "addQuotedLineRequired": "Ajoutez au moins une ligne produit cotée avec prix unitaire",
    "recordQuotationFailed": "Échec de l'enregistrement du devis",
    "selectStoreFirst": "Sélectionnez d'abord un magasin",
    "createPoFailed": "Échec de la création de la commande",
    "selectQuotationFailed": "Échec de la sélection du devis",
    "exportFailed": "Échec de l'export",
    "orgContextRequired": "Contexte organisation requis",
    "requestLinkFailed": "Échec de la demande de lien",
    "loadCatalogsFailed": "Échec du chargement des catalogues",
    "inviteFailed": "Échec de l'invitation",
    "selectSupplierRfq": "Sélectionnez au moins un fournisseur",
    "addProductLineQuantity": "Ajoutez au moins une ligne produit avec quantité",
    "setResponseDeadline": "Définissez une date limite de réponse",
    "createRfqFailed": "Échec de la création de l'appel d'offres",
    "loadVendorDashboardFailed": "Échec du chargement du tableau de bord fournisseur",
    "loadRfqFailed": "Échec du chargement de l'appel d'offres",
    "addQuotedProductLine": "Ajoutez au moins une ligne produit cotée",
    "submitQuotationFailed": "Échec de la soumission du devis",
    "selectPurchaseOrder": "Sélectionnez une commande d'achat",
    "addInvoiceLine": "Ajoutez au moins une ligne de facture",
    "submitInvoiceFailed": "Échec de la soumission de la facture",
    "verificationFailed": "Échec de la vérification",
    "createPurchaseRequestFailed": "Échec de la création de la demande d'achat",
    "loadMatchStatusFailed": "Échec du chargement du statut de rapprochement",
    "threeWayMatchFailed": "Échec du rapprochement tripartite",
    "addProductLine": "Ajoutez au moins une ligne produit",
    "createVendorBillFailed": "Échec de la création de la facture fournisseur",
    "selectVendorBillId": "Sélectionnez un ID de facture fournisseur valide",
    "enterValidAmount": "Saisissez un montant valide",
    "paymentPostingFailed": "Échec de la comptabilisation du paiement",
    "qcSubmissionFailed": "Échec de la soumission QC",
    "grnPostFailed": "Échec de la comptabilisation du GRN",
    "autoReorderFailed": "Échec du réapprovisionnement automatique",
    "failedToLoadContracts": "Échec du chargement de contracts",
    "failedToLoadGrns": "Échec du chargement de gRNs",
    "failedToLoadPos": "Échec du chargement de pOs",
    "failedToLoadPurchaseRequests": "Échec du chargement de purchase requests",
    "failedToLoadRfqs": "Échec du chargement de rFQs",
    "failedToLoadVendorBills": "Échec du chargement de vendor bills",
    "failedToLoadVendorPayments": "Échec du chargement de vendor payments"
  },
  "labels": {
    "store": "Magasin *",
    "requiredByDate": "Requis by date",
    "notes": "Notes",
    "reasonOrDeliveryInstructions": "Reason ou delivery instructions",
    "rfq": "RFQ *",
    "supplier": "Fournisseur *",
    "deliveryDate": "Delivery date",
    "paymentTerms": "Paiement terms",
    "purchaseRequestOptional": "Purchase request (facultatif)",
    "responseDeadline": "Response deadline *",
    "suppliers": "Fournisseurs *",
    "selectApprovedPurchaseRequest": "Select approuvé purchase request",
    "optionalInstructionsForSuppliers": "Optional instructions pour fournisseurs",
    "vendorEmail": "Vendor email",
    "poOptional": "PO (facultatif)",
    "grnIdOptional": "GRN ID (facultatif)",
    "supplierInvoice": "Fournisseur facture #",
    "billDate": "Bill date",
    "dueDate": "Date d'échéance",
    "vendorBill": "Vendor bill",
    "amount": "Montant",
    "selectVendorBill": "Select vendor bill",
    "warrantyTerms": "Warranty terms",
    "purchaseOrder": "Purchase order *",
    "supplierEmail": "Fournisseur email"
  },
  "formActions": {
    "createAndPostPayment": "Créer et comptabiliser le paiement"
  },
  "listActions": {
    "submitRequest": "Soumettre la demande",
    "runAutoReorder": "Lancer le réapprovisionnement auto",
    "backToProcurement": "Retour aux achats"
  },
  "reports": {
    "formats": {
      "csv": "CSV",
      "excel": "Excel",
      "pdf": "PDF"
    },
    "types": {
      "goodsReceipts": "Réceptions marchandises",
      "purchaseOrders": "Commandes d'achat",
      "purchaseRequests": "Demandes d'achat",
      "rfqs": "Appels d'offres",
      "spendAnalysis": "Analyse des dépenses",
      "vendorBills": "Factures fournisseurs"
    }
  }
}
